<template>
  <div style="text-align: -webkit-center">
    <div ref="setWidth" class="setKonvaWidth"></div>
    <div
      id="template3Set"
      style="
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
      "
    >
      <template v-if="!loadingImg">
        <v-stage
          ref="stage1"
          style="text-align: -webkit-center; background: #688bbc; !important"
          class="mt-5"
          :config="{
            width: templateSelect.content_json.size.width * scaleState,
            height: templateSelect.content_json.size.height * scaleState
          }"
        >
          <v-layer ref="layer">
            <v-image
              v-if="templateSelect.content_json.selected"
              :config="{
                image: image,
                width: templateSelect.content_json.size.width * scaleState,
                height: templateSelect.content_json.size.height * scaleState
              }"
            />
          </v-layer>
        </v-stage>
      </template>

      <div class="pl-4 keyboard py-2">
        <v-icon style="font-size: 35px; float: left" color="#ffffff"
          >mdi-keyboard</v-icon
        >
        <div
          class="pa-1 text-center"
          style="padding-right: 40px !important; min-height: 32px"
        >
          <span
            >{{ value }}
            <v-icon v-if="templateSelect.content_json.selected" color="#ffffff">
              mdi-menu-down
            </v-icon>
            <v-icon v-else color="#ffffff"> mdi-menu-up </v-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data() {
    return {
      image: null,
      maxWidth: 0,
      loadingImg: true
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect'
    }),
    scaleState() {
      return this.maxWidth / this.templateSelect.content_json.size.width
    }
  },
  async mounted() {
    this.loadingImg = true
    this.templateSelect.content_json.areas.map((item) => {
      if (item.action.type === 'uri') {
        if (item.action.uri.split(':')[0] === 'tel') {
          item.action.type = 'phone_number'
          item.action.phone_number = item.action.uri.split(':')[1]
        } else {
          //
          if (item.action.uri.includes('link.zwiz.ai')) {
            var urlParams = new URLSearchParams(item.action.uri)
            if (urlParams.has('rurl')) {
              item.action.uri = urlParams.get('rurl')
            }
          }
        }
      }
      if (item.action.type === 'postback') {
        if (item.action.data.indexOf('nextrichmenu:') != -1) {
          item.action.type = 'rich_menu'
        } else if (item.action.data.indexOf('pb=') != -1) {
          try {
            var data = item.action.data.split('|')
            if (data.length >= 2) {
              item.action.data = data[1]
            }
          } catch (error) {
            //
          }
        }
      }
    })
    this.image = await this.loadImage(this.templateSelect.image_url)
    await this.$nextTick()
    this.loadingImg = false
    if (this.$refs.setWidth.clientWidth) {
      this.maxWidth = this.$refs.setWidth.clientWidth
    }
  }
}
</script>

<style lang="scss" scoped></style>
